import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from "docz";
import StaticTable from "./StaticTable";
import Icon from "../Icon/Icon.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "statictable"
    }}>{`StaticTable`}</h1>
    <Props of={StaticTable} mdxType="Props" />
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <p>{`This is the simplest way to use the `}<inlineCode parentName="p">{`StaticTable`}</inlineCode>{`. You must define the `}<inlineCode parentName="p">{`topHeaders`}</inlineCode>{` as shown. Each item will be the title for each column. You can use the table tags just as you would do it on plain HTML.`}</p>
    <Playground __position={1} __code={'<StaticTable\n  topHeaders={[\n    \'Fullname\',\n    \'Age\',\n    \'Favorite color\',\n    \'Instrument\',\n    \'How many Grammys?\',\n    \'genre\',\n    \'Is registered?\',\n  ]}\n>\n  <tr>\n    <td>John Lennon</td>\n    <td>40</td>\n    <td>blue</td>\n    <td>guitar, piano, vocals</td>\n    <td>4</td>\n    <td>Rock</td>\n    <td>\n      <Icon name=\"checkmark\" size=\"36px\" altText=\"checkmark icon\" />\n    </td>\n  </tr>\n  <tr>\n    <td>David Gilmour</td>\n    <td>52</td>\n    <td>red</td>\n    <td>guitar, vocals</td>\n    <td>0</td>\n    <td>Progressive rock</td>\n    <td>\n      <Icon name=\"checkmark\" size=\"36px\" altText=\"checkmark icon\" />\n    </td>\n  </tr>\n  <tr>\n    <td>Charlie Parker</td>\n    <td>32</td>\n    <td>yellow</td>\n    <td>saxophone</td>\n    <td>4</td>\n    <td>Jazz</td>\n    <td>\n      <Icon name=\"close\" size=\"36px\" altText=\"close icon\" />\n    </td>\n  </tr>\n</StaticTable>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StaticTable,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      <StaticTable topHeaders={['Fullname', 'Age', 'Favorite color', 'Instrument', 'How many Grammys?', 'genre', 'Is registered?']} mdxType="StaticTable">
  <tr>
    <td>John Lennon</td>
    <td>40</td>
    <td>blue</td>
    <td>guitar, piano, vocals</td>
    <td>4</td>
    <td>Rock</td>
    <td><Icon name="checkmark" size="36px" altText="checkmark icon" mdxType="Icon" /></td>
  </tr>
  <tr>
    <td>David Gilmour</td>
    <td>52</td>
    <td>red</td>
    <td>guitar, vocals</td>
    <td>0</td>
    <td>Progressive rock</td>
    <td><Icon name="checkmark" size="36px" altText="checkmark icon" mdxType="Icon" /></td>
  </tr>
  <tr>
    <td>Charlie Parker</td>
    <td>32</td>
    <td>yellow</td>
    <td>saxophone</td>
    <td>4</td>
    <td>Jazz</td>
    <td><Icon name="close" size="36px" altText="close icon" mdxType="Icon" /></td>
  </tr>
      </StaticTable>
    </Playground>
    <h2 {...{
      "id": "left-row-headers"
    }}>{`Left row headers`}</h2>
    <p>{`You can define left row headers using the class `}<inlineCode parentName="p">{`row-header`}</inlineCode>{` on the first element of each row. You should also use the `}<inlineCode parentName="p">{`<th></th>`}</inlineCode>{` tag instead of `}<inlineCode parentName="p">{`<td>`}</inlineCode>{` but it's not mandatory in order to make it work.`}</p>
    <Playground __position={2} __code={'<StaticTable\n  topHeaders={[\n    \'Fullname\',\n    \'Age\',\n    \'Favorite color\',\n    \'Instrument\',\n    \'How many Grammys?\',\n    \'genre\',\n    \'Is registered?\',\n  ]}\n>\n  <tr>\n    <th className=\"row-header\">John Lennon</th>\n    <td>40</td>\n    <td>blue</td>\n    <td>guitar, piano, vocals</td>\n    <td>4</td>\n    <td>Rock</td>\n    <td>\n      <Icon name=\"checkmark\" size=\"36px\" altText=\"checkmark icon\" />\n    </td>\n  </tr>\n  <tr>\n    <td className=\"row-header\">David Gilmour</td>\n    <td>52</td>\n    <td>red</td>\n    <td>guitar, vocals</td>\n    <td>0</td>\n    <td>Progressive rock</td>\n    <td>\n      <Icon name=\"checkmark\" size=\"36px\" altText=\"checkmark icon\" />\n    </td>\n  </tr>\n  <tr>\n    <th className=\"row-header\">Charlie Parker</th>\n    <td>32</td>\n    <td>yellow</td>\n    <td>saxophone</td>\n    <td>4</td>\n    <td>Jazz</td>\n    <td>\n      <Icon name=\"close\" size=\"36px\" altText=\"close icon\" />\n    </td>\n  </tr>\n</StaticTable>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StaticTable,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      <StaticTable topHeaders={['Fullname', 'Age', 'Favorite color', 'Instrument', 'How many Grammys?', 'genre', 'Is registered?']} mdxType="StaticTable">
  <tr>
    <th className='row-header'>John Lennon</th>
    <td>40</td>
    <td>blue</td>
    <td>guitar, piano, vocals</td>
    <td>4</td>
    <td>Rock</td>
    <td><Icon name="checkmark" size="36px" altText="checkmark icon" mdxType="Icon" /></td>
  </tr>
  <tr>
    <td className='row-header'>David Gilmour</td>
    <td>52</td>
    <td>red</td>
    <td>guitar, vocals</td>
    <td>0</td>
    <td>Progressive rock</td>
    <td><Icon name="checkmark" size="36px" altText="checkmark icon" mdxType="Icon" /></td>
  </tr>
  <tr>
    <th className='row-header'>Charlie Parker</th>
    <td>32</td>
    <td>yellow</td>
    <td>saxophone</td>
    <td>4</td>
    <td>Jazz</td>
    <td><Icon name="close" size="36px" altText="close icon" mdxType="Icon" /></td>
  </tr>
      </StaticTable>
    </Playground>
    <h2 {...{
      "id": "max-items"
    }}>{`Max items`}</h2>
    <p>{`It happens that sometimes you need to show a long table with a lot of rows. You can set the amount of rows you want to show from that list using the attribute `}<inlineCode parentName="p">{`displayCount`}</inlineCode>{` as you can see below. If the number assigned to `}<inlineCode parentName="p">{`displayCount`}</inlineCode>{` is bigger than the rows in your table, this attribute wont have any effect.`}</p>
    <p>{`When using the `}<inlineCode parentName="p">{`displayCount`}</inlineCode>{` attribute, a button will appear at the bottom of the table with a "Show more" text. It will toggle between the total of rows and the defined by you in `}<inlineCode parentName="p">{`displayCount`}</inlineCode>{`.`}</p>
    <Playground __position={3} __code={'<StaticTable\n  rows={{ displayCount: 4 }}\n  topHeaders={[\n    \'Fullname\',\n    \'Age\',\n    \'Favorite color\',\n    \'Instrument\',\n    \'How many Grammys?\',\n    \'genre\',\n    \'Is registered?\',\n  ]}\n>\n  <tr>\n    <th className=\"row-header\">John Lennon</th>\n    <td>40</td>\n    <td>blue</td>\n    <td>guitar, piano, vocals</td>\n    <td>4</td>\n    <td>Rock</td>\n    <td>\n      <Icon name=\"checkmark\" size=\"36px\" altText=\"checkmark icon\" />\n    </td>\n  </tr>\n  <tr>\n    <th className=\"row-header\">David Gilmour</th>\n    <td>52</td>\n    <td>red</td>\n    <td>guitar, vocals</td>\n    <td>0</td>\n    <td>Progressive rock</td>\n    <td>\n      <Icon name=\"checkmark\" size=\"36px\" altText=\"checkmark icon\" />\n    </td>\n  </tr>\n  <tr>\n    <th className=\"row-header\">Charlie Parker</th>\n    <td>32</td>\n    <td>yellow</td>\n    <td>saxophone</td>\n    <td>4</td>\n    <td>Jazz</td>\n    <td>\n      <Icon name=\"close\" size=\"36px\" altText=\"close icon\" />\n    </td>\n  </tr>\n  <tr>\n    <th className=\"row-header\">Michael Jackson</th>\n    <td>48</td>\n    <td>gold</td>\n    <td>vocals</td>\n    <td>13</td>\n    <td>Pop</td>\n    <td>\n      <Icon name=\"checkmark\" size=\"36px\" altText=\"checkmark icon\" />\n    </td>\n  </tr>\n  <tr>\n    <th className=\"row-header\">Kurt Cobain</th>\n    <td>24</td>\n    <td>purple</td>\n    <td>guitar, vocals</td>\n    <td>1</td>\n    <td>Grunge</td>\n    <td>\n      <Icon name=\"close\" size=\"36px\" altText=\"close icon\" />\n    </td>\n  </tr>\n  <tr>\n    <th className=\"row-header\">Elvis Presley</th>\n    <td>38</td>\n    <td>white</td>\n    <td>guitar, vocals</td>\n    <td>10</td>\n    <td>Rock and roll</td>\n    <td>\n      <Icon name=\"checkmark\" size=\"36px\" altText=\"checkmark icon\" />\n    </td>\n  </tr>\n  <tr>\n    <th className=\"row-header\">Kurt Cobain</th>\n    <td>24</td>\n    <td>purple</td>\n    <td>guitar, vocals</td>\n    <td>1</td>\n    <td>Grunge</td>\n    <td>\n      <Icon name=\"close\" size=\"36px\" altText=\"close icon\" />\n    </td>\n  </tr>\n  <tr>\n    <th className=\"row-header\">Elvis Presley</th>\n    <td>38</td>\n    <td>white</td>\n    <td>guitar, vocals</td>\n    <td>10</td>\n    <td>Rock and roll</td>\n    <td>\n      <Icon name=\"checkmark\" size=\"36px\" altText=\"checkmark icon\" />\n    </td>\n  </tr>\n</StaticTable>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StaticTable,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      <StaticTable rows={{
        displayCount: 4
      }} topHeaders={['Fullname', 'Age', 'Favorite color', 'Instrument', 'How many Grammys?', 'genre', 'Is registered?']} mdxType="StaticTable">
  <tr>
    <th className='row-header'>John Lennon</th>
    <td>40</td>
    <td>blue</td>
    <td>guitar, piano, vocals</td>
    <td>4</td>
    <td>Rock</td>
    <td><Icon name="checkmark" size="36px" altText="checkmark icon" mdxType="Icon" /></td>
  </tr>
  <tr>
    <th className='row-header'>David Gilmour</th>
    <td>52</td>
    <td>red</td>
    <td>guitar, vocals</td>
    <td>0</td>
    <td>Progressive rock</td>
    <td><Icon name="checkmark" size="36px" altText="checkmark icon" mdxType="Icon" /></td>
  </tr>
  <tr>
    <th className='row-header'>Charlie Parker</th>
    <td>32</td>
    <td>yellow</td>
    <td>saxophone</td>
    <td>4</td>
    <td>Jazz</td>
    <td><Icon name="close" size="36px" altText="close icon" mdxType="Icon" /></td>
  </tr>
    <tr>
    <th className='row-header'>Michael Jackson</th>
    <td>48</td>
    <td>gold</td>
    <td>vocals</td>
    <td>13</td>
    <td>Pop</td>
    <td><Icon name="checkmark" size="36px" altText="checkmark icon" mdxType="Icon" /></td>
  </tr>
  <tr>
    <th className='row-header'>Kurt Cobain</th>
    <td>24</td>
    <td>purple</td>
    <td>guitar, vocals</td>
    <td>1</td>
    <td>Grunge</td>
    <td><Icon name="close" size="36px" altText="close icon" mdxType="Icon" /></td>
  </tr>
  <tr>
    <th className='row-header'>Elvis Presley</th>
    <td>38</td>
    <td>white</td>
    <td>guitar, vocals</td>
    <td>10</td>
    <td>Rock and roll</td>
    <td><Icon name="checkmark" size="36px" altText="checkmark icon" mdxType="Icon" /></td>
  </tr>
    <tr>
    <th className='row-header'>Kurt Cobain</th>
    <td>24</td>
    <td>purple</td>
    <td>guitar, vocals</td>
    <td>1</td>
    <td>Grunge</td>
    <td><Icon name="close" size="36px" altText="close icon" mdxType="Icon" /></td>
  </tr>
  <tr>
    <th className='row-header'>Elvis Presley</th>
    <td>38</td>
    <td>white</td>
    <td>guitar, vocals</td>
    <td>10</td>
    <td>Rock and roll</td>
    <td><Icon name="checkmark" size="36px" altText="checkmark icon" mdxType="Icon" /></td>
  </tr>
      </StaticTable>
    </Playground>
    <h2 {...{
      "id": "aditional-types"
    }}>{`Aditional types`}</h2>
    <h3 {...{
      "id": "product-atributes"
    }}>{`Product atributes`}</h3>
    <Playground __position={4} __code={'<h3>Product atributes</h3>\n<StaticTable\n  topHeaders={[\'Type of Discount\', \'Description\']}\n  className=\"product-attributes\"\n>\n  <tr>\n    <td>Multi-car</td>\n    <td>Insure more than one car and save up to 26% on your premiums</td>\n  </tr>\n  <tr>\n    <td>Responsible driver</td>\n    <td>\n      If you go five years without any accidents, you can save up to 5% on\n      some coverage options\n    </td>\n  </tr>\n  <tr>\n    <td>Good Student</td>\n    <td>\n      If you have students that maintain good grades, you could recieve up to\n      6% off certain coverage options. Most states require policyholders to be\n      between the ages of 16 and 25 and full-time students with a \"B\" average\n      or better\n    </td>\n  </tr>\n  <tr>\n    <td>Bundling</td>\n    <td>\n      Bundling your car insurance policy with your homeowners, renters or\n      motorcycle insurance policies can earn you discounted rates\n    </td>\n  </tr>\n</StaticTable>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StaticTable,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <h3>Product atributes</h3>
  <StaticTable topHeaders={['Type of Discount', 'Description']} className="product-attributes" mdxType="StaticTable">
    <tr>
      <td>Multi-car</td>
      <td>Insure more than one car and save up to 26% on your premiums</td>
    </tr>
    <tr>
      <td>Responsible driver</td>
      <td>If you go five years without any accidents, you can save up to 5% on some coverage options</td>
    </tr>
    <tr>
      <td>Good Student</td>
      <td>If you have students that maintain good grades, you could recieve up to 6% off certain coverage options. Most states require policyholders to be between the ages of 16 and 25 and full-time students with a "B" average or better</td>
    </tr>
    <tr>
      <td>Bundling</td>
      <td>Bundling your car insurance policy with your homeowners, renters or motorcycle insurance policies can earn you discounted rates</td>
    </tr>
  </StaticTable>
    </Playground>
    <h3 {...{
      "id": "headless-list"
    }}>{`Headless List`}</h3>
    <Playground __position={5} __code={'<h3>Headless list</h3>\n<StaticTable\n  topHeaders={[\'Type of Discount\', \'Description\']}\n  className=\"headless-list\"\n>\n  <tr>\n    <td>Multi-car</td>\n    <td>Insure more than one car and save up to 26% on your premiums</td>\n  </tr>\n  <tr>\n    <td>Responsible driver</td>\n    <td>\n      If you go five years without any accidents, you can save up to 5% on\n      some coverage options\n    </td>\n  </tr>\n  <tr>\n    <td>Good Student</td>\n    <td>\n      If you have students that maintain good grades, you could recieve up to\n      6% off certain coverage options. Most states require policyholders to be\n      between the ages of 16 and 25 and full-time students with a \"B\" average\n      or better\n    </td>\n  </tr>\n  <tr>\n    <td>Bundling</td>\n    <td>\n      Bundling your car insurance policy with your homeowners, renters or\n      motorcycle insurance policies can earn you discounted rates\n    </td>\n  </tr>\n</StaticTable>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StaticTable,
      Icon,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <h3>Headless list</h3>
  <StaticTable topHeaders={['Type of Discount', 'Description']} className="headless-list" mdxType="StaticTable">
    <tr>
      <td>Multi-car</td>
      <td>Insure more than one car and save up to 26% on your premiums</td>
    </tr>
    <tr>
      <td>Responsible driver</td>
      <td>If you go five years without any accidents, you can save up to 5% on some coverage options</td>
    </tr>
    <tr>
      <td>Good Student</td>
      <td>If you have students that maintain good grades, you could recieve up to 6% off certain coverage options. Most states require policyholders to be between the ages of 16 and 25 and full-time students with a "B" average or better</td>
    </tr>
    <tr>
      <td>Bundling</td>
      <td>Bundling your car insurance policy with your homeowners, renters or motorcycle insurance policies can earn you discounted rates</td>
    </tr>
  </StaticTable>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      